import { useMediaQuery } from '@mui/material';
import React from 'react';
import { ReactComponent as AlertIcon } from '../../../../assets/images/alert-circle.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
export var CloseIRModal = function (_ref) {
    var onClose = _ref.onClose;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            gap: '16px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    display: 'flex',
                    justifyContent: 'space-between',
                    columnSize: 12,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(AlertIcon, {
                                height: '20px',
                                width: '20px'
                            }),
                            columnSize: 0,
                            sx: {
                                bgcolor: 'warning.100',
                                cursor: 'default',
                                padding: '12px',
                                color: 'warning.500',
                                ':hover': {
                                    bgcolor: 'warning.100'
                                }
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                fontSize: "small",
                                color: "secondary"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            },
                            size: 'small',
                            color: 'secondary'
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Msg',
                    label: "Are you sure you want to Close IR",
                    value: null,
                    columnSize: 12,
                    children: "Actions taken cannot be undone.",
                    labelTypographyProps: {
                        fontSize: "xl",
                        fontWeight: 'strong',
                        color: 'text.primary'
                    },
                    color: 'secondary.600'
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: '',
                    label: 'Status',
                    columnSize: 12,
                    placeholder: 'E.g. Action updated by service'
                }, {
                    type: FormItemTypes.DatePicker,
                    name: '',
                    label: 'Cutt off date',
                    columnSize: 12,
                    placeholder: 'E.g. 6 Jan, 2025'
                }, {
                    type: FormItemTypes.TextInput,
                    name: '',
                    label: 'PSG remarks',
                    columnSize: 12,
                    multiline: true,
                    minRows: 4,
                    placeholder: 'Enter a description'
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            gap: 1.5,
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'end',
            spacing: 0,
            sx: {
                paddingTop: '24px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Cancel',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'outlined',
                    onClick: function () {
                        onClose();
                    },
                    color: 'secondary'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Confirm',
                    onClick: function () {
                        onClose('confirm');
                    },
                    color: 'primary',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'contained'
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        gridProps: {
            p: 2,
            gap: 2,
            spacing: 0
        }
    });
};
